import {Card} from '@vector';
import {ArrowRightUpBoldIcon} from '@solar-icons/react';
import styles from './OtherProductsCard.module.css';

export default function OtherProductsCard({content}) {
    return (
        <section className={styles.section}>
            <Card as="a" href={content.link.href} surface="secondary" className={styles.card}>
                <div className={styles.text}>
                    <h2 className={styles.heading}>{content.heading}</h2>
                    <p className={styles.body}>{content.body}</p>
                </div>
                <span className={styles.pill}>
                    {content.link.label}
                    <ArrowRightUpBoldIcon size={20}/>
                </span>
            </Card>
        </section>
    );
}
